import React, { useEffect, useState } from "react";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

const PatientEvolutions = ({ selectedPatient }) => {
  const [evolutions, setEvolutions] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          const evolutionsData = data.evolutions || {};

          const sortedEvolutions = Object.entries(evolutionsData).sort(
            ([, a], [, b]) => new Date(b.date) - new Date(a.date)
          );

          setEvolutions(sortedEvolutions);
        } else {
          setEvolutions({});
        }
      },
      (error) => {
        setError("Ocurrió un error al cargar las evoluciones.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  const formatDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="dataHistory">
      {error && <p style={{ color: "red" }}>{error}</p>}

      {evolutions && evolutions.length > 0 ? (
        <ul className="dataList">
          {evolutions.map(([key, value], index) => (
            <li key={index} className="dataItem">
              {value.observation} | {value.user} - {formatDate(value.date)}
            </li>
          ))}
        </ul>
      ) : (
        <p>Todavía no hay evoluciones registradas.</p>
      )}
    </div>
  );
};

export default PatientEvolutions;
